import PropTypes from 'prop-types'
import React from 'react'

import CostsStockAndBase from 'components/CostsStockAndBase'
import CostContainer from 'containers/CostContainer'

const CostContainerSale = ({
  productType,
  isSubscription,
  isWhite,
  isCenter,
  isMobileCenter,
  isTabNotCenter,
  size,
  crossedSize,
  isTransparent,
  className,
}) => (
  <CostContainer {...{ productType, isSubscription }}>
    {costProps => (
      <CostsStockAndBase
        {...{
          ...costProps,
          isWhite,
          isCenter,
          isMobileCenter,
          isTabNotCenter,
          size,
          crossedSize,
          isTransparent,
          className,
        }}
      />
    )}
  </CostContainer>
)

CostContainerSale.propTypes = {
  productType: PropTypes.string.isRequired,
  isCenter: PropTypes.bool,
  isMobileCenter: PropTypes.bool,
  isTabNotCenter: PropTypes.bool,
  isSubscription: PropTypes.bool,
  isWhite: PropTypes.bool,
  isTransparent: PropTypes.bool,
  size: PropTypes.string,
  crossedSize: PropTypes.string,
  className: PropTypes.string,
}

CostContainerSale.defaultProps = {
  isSubscription: false,
  isTransparent: true,
}

export default CostContainerSale
